module.exports = __webpack_public_path__ + "static/media/tommySleeve5.5bae6e0d.svg";